export default {
  DETAILS: 'DETAILS',
  ATTACHMENTS: 'ATTACHMENTS',
  CATALOG: 'CATALOG',
  DESCRIPTION: 'DESCRIPTION',
  LESSONS: 'LESSONS',
  EXAM: 'EXAM',
  INTEGRATIONS: 'INTEGRATIONS',
};
